import React, { useCallback, memo } from 'react';

import {
    formatNumber,
    formatYear,
    formatDate,
    getLocationWithoutCampa,
} from 'js/components/shared/vehicleFunctions';

const Body = ({ vehicle, translations }) => {
    const printRegistrationDate = useCallback(() => {
        let date = null;
        if (vehicle.RegistrationDate) {
            if (vehicle.WebSalesId)
                date = <li>{formatDate(vehicle.RegistrationDate, false)} </li>;
            else if (vehicle.RepurchaseObligation >= 0)
                date = <li>{formatYear(vehicle.RegistrationDate)} </li>;
        }
        return date;
    }, [
        vehicle.RegistrationDate,
        vehicle.RepurchaseObligation,
        vehicle.WebSalesId,
    ]);

    const getVehicleLocation = useCallback(() => {
        let location = translations.getTraduction('WithoutLocation');
        if (vehicle.OriginDescription) {
            location = getLocationWithoutCampa(vehicle.OriginDescription);
        } else if (vehicle.RepurchaseObligation) {
            location = vehicle?.DealerReturn?.Description;
        }
        return location;
    }, [
        translations,
        vehicle?.DealerReturn?.Description,
        vehicle.OriginDescription,
        vehicle.RepurchaseObligation,
    ]);

    return (
        <div
            className="c-card__body u-pt-none u-pb-none"
            style={{ position: 'relative' }}
        >
            <ul className="c-vehicle-card__options-list">
                {printRegistrationDate()}
                {vehicle.Kms ? <li> {formatNumber(vehicle.Kms)} Km </li> : ''}
                {vehicle.CV ? <li> {vehicle.CV} CV </li> : ''}
                {vehicle.Energy ? <li> {vehicle.Energy} </li> : ''}
                <br />
                {vehicle.Transmission ? <li>{vehicle.Transmission}</li> : ''}
            </ul>
            <p className="c-vehicle-card__location">
                <i
                    className="c-icon c-icon--xsmall c-icon--[pin]"
                    aria-hidden="true"
                ></i>
                <span className="c-vehicle-card__location-text">
                    {getVehicleLocation()}
                </span>
            </p>
            <div
                style={{ position: 'absolute', bottom: '-5px', right: '10px' }}
            >
                {vehicle.AffectationMotorText}
            </div>
        </div>
    );
};

export default memo(Body);
